export default __webpack_public_path__ + "static/media/ICONE-COURO-MACIO.7420d0b4.svg";